import React from 'react';
import { Link } from 'gatsby'

import * as styles from './styles.module.css'

import { FaChevronRight } from 'react-icons/fa'

function CTA({ title, url, className })
{
  return (
    <div className={styles.ctaButton + " " + className + " cta-button text-lg px-6 py-3 rounded-3xl right-0 text-white font-semibold uppercase"}>
      <Link to={"/" + url.slug}>
        <span className="flex flex-row items-center">
          {title}
          <span className={styles.arrow}><FaChevronRight /></span>
        </span>
      </Link>
    </div>
  );
}

export default CTA;